import React from 'react'
import styled from '@emotion/styled'

import { Flex } from 'lese'
import { colors } from 'Constants'

const Header = styled(Flex)`
  padding: 8px 32px;
  border-bottom: 2px solid ${colors.borderColor};
`

export default ({ children }) => {
  return (
    <Header
      yAlign
      xAlign="space-between"
      style={{
        gridRow: 1,
        gridColumn: 2
      }}
    >
      {children}
    </Header>
  )
}
